import Component from '@glimmer/component';

import linkToState from 'ember-route-state/helpers/link-to-state.js';

import SearchButton from 'rise-ui/components/search-button.gjs';
import event from 'rise-ui/helpers/event.js';
import enter from 'rise-ui/modifiers/enter.js';

export default class SearchTermComponent extends Component {
  <template>
    <div class="c-search-term">
      <div class="c-search-term-field">
        <input type="text"
          aria-label={{@placeholder}}
          class="c-search-term-field-control qa-search-input"
          placeholder={{@placeholder}}
          value={{readonly @value}}
          oninput={{event @onInput}}
          {{enter (linkToState @route transition=true)}}
        >
      </div>
      <div class="c-search-term-button">
        <SearchButton
          @route={{@route}}
          @loading={{@loading}}
          @refresh={{@refresh}}
        />
      </div>
    </div>
  </template>
}
